import { useMutation, useQuery } from "@tanstack/react-query";
import { GET, POST, PUT } from "../../../../services";

// คีย์นี้อยู่ในรายการ invalidate ของ 'case:updated' ใน App.js — หน้านี้เป็นคิวงาน จึงได้ realtime
export const LINE_CASE_QUEUE_KEY = ["getFetchLineCaseQueue"];

export const useFetchLineCaseQueue = () =>
  useQuery(LINE_CASE_QUEUE_KEY, async () => {
    const { result } = await GET(`/api/v1/lineCaseQueue`);
    return result || [];
  });

export const useClaimLineCase = () =>
  useMutation({
    mutationFn: async ({ id, force = false }) => await POST(`/api/v1/lineCaseQueue/${id}/claim`, { force }),
  });

export const useReleaseLineCase = () =>
  useMutation({
    mutationFn: async (id) => await POST(`/api/v1/lineCaseQueue/${id}/release`, {}),
  });

// สองตัวนี้ยิง API เดิมของหน้า Input ตรง ๆ — พฤติกรรมเหมือนกดจากหน้า Input ทุกอย่าง
// (ส่งกลับไปหาคนที่ตีกลับ, ลง history_logs, realtime)
export const useResendLineCase = () =>
  useMutation({
    mutationFn: async (payload) => await PUT(`/api/v1/input`, payload),
  });

export const useCloseLineCase = () =>
  useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/input/cancelReject`, payload),
  });
